import React, {useEffect, useState} from 'react';
import SelectBox from "../Componnets/SelectBox";
import IPInput from "../Componnets/IPInput";
import PasswordInput from "../Componnets/PasswordInput";
import DropDown from "../Componnets/DropDown/DropDown";
import http from "../../services/api/utilities/http";
export default function SelectEventLog(props) {
    const [tables , setTables] = useState([])

    const sendData = () => {
        props.setTableDataPreview(tables)
        http.post('data_connector/data_preview/',{
                "data_source":props.table.id,
                "table":tables,
                "event_log_template":5
            })
            .then(res => {
                console.log('res',res.data)
                props.setDataPreview(res.data.data)
                props.goToPreview('Select Event Log');
            })
            .catch(err=>{
                console.log(err.response)
            })
    }
    return (
                 <div style={{width:839}}className="select-event-log">
                           <div className="mt-60">
                                 <h6>Choose Event Log Table/View</h6>
                                 <p style={{width:470}} className="blue-navy mb-24">If you already have a table for event logs choose it here, otherwise click on
                                   choosing automatically and we will do the magic for you</p>
                           <div className="d-flex align-items-center">
                               <DropDown  table={props.table} selectTable={setTables}/>
                               <div className="btn" onClick={sendData}>proceed</div>
                           </div>
                           </div>
                           {/*<div className="mt-40">*/}
                           {/*    <h6>YOU Don't know how to generate event logs?</h6>*/}
                           {/*    <p className="blue-navy">Let Us Do the Magic!</p>*/}
                           {/*</div>*/}
                 </div>
    );
}
